


























































import Vue, { PropType } from 'vue';
import FolderDeleteButton from './FolderDeleteButton.vue';
import Button from '../../components/common/Button/Button.vue';
import {
  AnalysisStateCode,
  AnalysisStatusI,
} from '../../interfaces/AnalysisStatusI';
import {
  requestDatasetFileAnalysis,
  requestLabelsetAnalysis,
} from '@/utils/axiosAgentInstance';

export default Vue.extend({
  components: {
    FolderDeleteButton,
    Button,
  },
  props: {
    folderName: { type: String },
    folderId: { type: String },
    folderAnalyzingStatus: {
      type: Object as PropType<AnalysisStatusI>,
      default: () => ({ status: 'DONE' as AnalysisStateCode }),
    },
    isInLabelsetSelectView: { type: Boolean },
  },
  data(): {
    isDashboardButtonVisible: boolean;
    statusText: {
      [Property in AnalysisStateCode]: string;
    };
  } {
    return {
      isDashboardButtonVisible: false,
      statusText: {
        DONE: '대시보드',
        ANALYZING: '분석 중',
        ERROR: '분석 중 에러 발생',
        READY: '분석 준비 중',
      },
    };
  },
  computed: {
    buttonClassObject: function (): {
      [Property in 'green' | 'red' | 'gray' | 'dataset-dashboard']: boolean;
    } {
      return {
        green:
          this.folderAnalyzingStatus.status === 'DONE' &&
          this.isInLabelsetSelectView,
        gray:
          (this.folderAnalyzingStatus.status === 'DONE' &&
            !this.isInLabelsetSelectView) ||
          this.folderAnalyzingStatus.status === 'READY' ||
          this.folderAnalyzingStatus.status === 'ANALYZING',
        red: this.folderAnalyzingStatus.status === 'ERROR',
        'dataset-dashboard': !this.isInLabelsetSelectView,
      };
    },
    isLabelset: function (): boolean {
      return this.$route.path.includes('dataset');
    },
  },
  mounted() {
    this.isDashboardButtonVisible = (
      this.$refs.folder as HTMLDivElement
    ).classList.contains('dashboard');
  },
  methods: {
    onClickDashboardMoveButton() {
      if (this.folderAnalyzingStatus.status === 'DONE') {
        if (this.isLabelset) {
          this.$router.push(
            this.$route.path + '/labelset/' + this.folderId + '/dashboard',
          );
        } else {
          this.$router.push(
            this.$route.path + '/dataset/' + this.folderId + '/dashboard',
          );
        }
      } else if (this.folderAnalyzingStatus.status === 'ERROR') {
        const isOk = confirm('다시 분석 시도하시겠습니까?');

        if (isOk) {
          this.$store.commit('startLoading');
          let requestPromise;
          if (this.isLabelset) {
            requestPromise = requestLabelsetAnalysis(this.folderId);
          } else {
            // const skipMetadata = confirm(
            //   '이미지 분석 시, 메타 데이터 분석을 생략할 수 있습니다.(실험적 기능)',
            // );
            requestPromise = requestDatasetFileAnalysis(this.folderId, false);
          }
          requestPromise
            .then(() => {
              alert('분석을 시작했습니다.');
              this.$router.go(0);
            })
            .catch((error) => {
              console.error(error);
              alert('분석 재시작에 실패했습니다.');
            })
            .finally(() => {
              this.$store.commit('stopLoading');
            });
        }
      }
    },
    onClickFolder() {
      if (this.isLabelset) {
        this.onClickDashboardMoveButton();
        return;
      }

      this.$emit('onClickFolder', {
        folderId: this.folderId,
        folderName: this.folderName,
      });
    },
    onClickDelete() {
      this.$emit('onClickDelete', {
        folderId: this.folderId,
        folderName: this.folderName,
      });
    },
  },
});
